import { render, staticRenderFns } from "./StaffGrid4PeopleList.vue?vue&type=template&id=7f6426df&scoped=true"
import script from "./StaffGrid4PeopleList.vue?vue&type=script&lang=js"
export * from "./StaffGrid4PeopleList.vue?vue&type=script&lang=js"
import style0 from "./StaffGrid4PeopleList.vue?vue&type=style&index=0&id=7f6426df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6426df",
  null
  
)

export default component.exports